import { configureStore } from '@reduxjs/toolkit';
import cusInvoiceTableReducer from './CusInvoiceTableStore';

export default configureStore({
    reducer: {
        cusInvoiceTable: cusInvoiceTableReducer,
    }
})